(function() {
  function toggleDrawer(drawer, open) {
    if (open) {
      drawer.classList.add('active');
      document.body.classList.add('yana-product-custom-drawer-opened', 'no-doc-scroll');
    } else {
      drawer.classList.remove('active');
      document.body.classList.remove('yana-product-custom-drawer-opened', 'no-doc-scroll');
    }
  }

    const drawers = document.querySelectorAll('.yana-product-custom-drawer');

    console.log('Custom drawers found:', drawers);

    drawers.forEach(drawer => {
        const openButtons = drawer.querySelectorAll('.yana-product-custom-drawer-open');
        const closeButtons = drawer.querySelectorAll('.yana-product-custom-drawer-close, .yana-product-custom-drawer-overlay-close');
        const modalContent = drawer.querySelector('.yana-product-custom-drawer-modal');

        console.log('buttons found:', openButtons.length, closeButtons.length);

        openButtons.forEach(button => {
            console.log('Adding click listener to button', button);
            button.addEventListener('click', () => {
                console.log('Opening drawer', modalContent);
                toggleDrawer(modalContent, true);
            });
        });

        closeButtons.forEach(button => {
            button.addEventListener('click', () => {
                toggleDrawer(modalContent, false);
            });
        });
    });
})();